const initialState = {
  HOME_INSTRUCTIONS: 'Select a word or phrase to learn sign language.',
  HOME_VENDOR_WELCOME: 'Welcome to',
  HOME_WELCOME: 'Welcome to',
  SIGN_THANK_YOU:
    'Thank you for taking the first step in learning sign language with the Speak2Sign app – we hope to see you again soon at Union Market to learn another word!',
  SIGN_LOADER_LINE_ONE: 'You selected',
  SIGN_LOADER_LINE_TWO: 'Here is how you say',
  SIGN_KEYFIELD_MESSAGE: 'Enter your phone number below to get the app:',
  SIGN_KEYCONTROL_BUTTON: 'Go back to all words',
  SIGN_KEYFORM_SUBMIT: 'Submit',
  SIGN_KEYPAD_INFO: 'Continue learning American Sign Language with <strong>The ASL App</strong>'
};

export default function(state) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/text/index.js